import { isCoach } from "@/components/helpers/workspace/permissions";
import { getUser, isImpersonating } from "@/components/session/JwtTokenManager";
import { MiniUserType } from "@/graphql";

export default function canUseAllTimeslot(coach: Pick<MiniUserType, "id">) {
  const user = getUser();

  if (user?.isStaff || user?.isSuperuser) {
    return true;
  }

  if (isCoach() && coach?.id == user?.id) {
    return true;
  }

  if (isImpersonating() && !user?.isAgent) {
    return true;
  }

  return false;
}
